module.exports = __webpack_public_path__ + "media/images/template_help-50cfbf5813baa7ab47b361b722163aca.png";